import React, { Component } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ActionStatus, GamePlayerStatus } from '../../../../../Constants';
import {
    availableAmenities,
    availableBeds,
    sellableRoomIndexesInStorage,
    unUpgradedRoomIndexesInStorage
} from '../../../../Game/GamePlayerInfo';
import { getTextureUrl } from '../../../Common/TextureTools';
import { ASSETS_URL } from '../../../../../Settings';


export default class ResearchController extends Component {

    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            nextProps.gamePlayerData.status === GamePlayerStatus.RESEARCHING_ID ||
            nextProps.gamePlayerData.action_status === ActionStatus.WAIT_ID
        )
    }

    componentDidMount() {
        this.highlightStorage();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.highlightStorage();
    }

    componentWillUnmount() {
        window.dispatchEvent(new Event('clear-storage-highlight-event'));
    }

    onFirstStorageClick = (storageIndex) => {
        let success = false;
        if (this.researchData.sellable.includes(storageIndex)) {
            this.api.researchSell(storageIndex);
            success = true;
        } else if (this.researchData.unupgraded.includes(storageIndex)) {
            this.api.researchUpgrade(storageIndex);
            success = true;
        } else {
            console.warn('Invalid research choice');
        }
        if (success) {
            window.dispatchEvent(new Event('clear-storage-highlight-event'));
        }
    };

    buyAmenity = (swiper) => {
        const amenityId = this.researchData.amenities[swiper.clickedIndex];
        this.api.researchBuyByRoomId(amenityId);
    }

    buyBed = (swiper) => {
        const bedId = this.researchData.beds[swiper.clickedIndex];
        // deal with clicking empty slot.
        this.api.researchBuyByRoomId(bedId);
    }

    highlightStorage = () => {
        setTimeout(() => {
            const rooms = [...this.researchData.unupgraded, ...this.researchData.sellable];
            window.dispatchEvent(
                new CustomEvent('highlight-storage-event',
                    {
                        detail: {
                            indexes: rooms,
                            callback: this.onFirstStorageClick
                        }
                    }));
        }, 500);
    }

    render() {
        if (
            this.props.gamePlayerData.status !== GamePlayerStatus.RESEARCHING_ID ||
            this.props.gamePlayerData.action_status !== ActionStatus.WAIT_ID
        ) return <></>

        this.researchData = {
            unupgraded: unUpgradedRoomIndexesInStorage(this.props.gamePlayerData),
            sellable: sellableRoomIndexesInStorage(this.props.gamePlayerData),
            amenities: availableAmenities(this.props.gameData),
            beds: availableBeds(this.props.gameData),
        }
        return <div className={'research-action'}>
            <div className={'research-action-anchor'}>
                <img
                    src={`${ASSETS_URL}overlays/ResearchOverlay-1080x210.png`}
                    alt="action"
                    className={'swiper-overlay'}
                />
                <Swiper
                    slidesPerView={6}
                    spaceBetween={0}
                    onClick={this.buyAmenity}  // this is an ADD click
                    // className="action-scroller-swiper"
                >
                    {this.researchData.amenities.map((textureId, index) => {
                        return <SwiperSlide key={`gi-${index}`}
                                            virtualIndex={index}>
                            <img
                                src={getTextureUrl(textureId)}
                                alt="research"
                                // className={'draft-card-img'}
                            />
                        </SwiperSlide>
                    })}
                </Swiper>
            </div>
            <div className={'research-action-anchor'}>
                <img
                    src={`${ASSETS_URL}overlays/ResearchOverlay-1080x210.png`}
                    alt="action"
                    className={'swiper-overlay'}
                />
                <Swiper
                    slidesPerView={6}
                    spaceBetween={0}
                    onClick={this.buyBed}  // this is an ADD click
                    // className="action-scroller-swiper"
                >
                    {this.researchData.beds.map((textureId, index) => {
                        return <SwiperSlide key={`gi-${index}`}
                                            virtualIndex={index}>
                            <img
                                src={getTextureUrl(textureId)}
                                alt="research"
                                // className={'draft-card-img'}
                            />
                        </SwiperSlide>
                    })}
                </Swiper>
            </div>
        </div>;
    }

}
